import { Screen } from '~/screens/users/activations/new';

export const UsersActivationsNew: React.FC = () => <Screen />;
